import { Column, CreateDateColumn, Entity, JoinColumn, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { SaleOrder } from "../sale-order.entitiy";

@Entity('documents_approval')
export class DocumentsApproval {
    @PrimaryGeneratedColumn("increment", { name: 'documents_approval_id' })
    documentsApprovalId: number;

    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;


    @Column("boolean", {
        nullable: true,
        name: "customs_invoice_upload",
        default: false
    })
    customsInvoiceUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "common_invoice_upload",
        default: false
    })
    commonInvoiceUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "commercial_packing_list_uploaded",
        default: false
    })
    commercialPackingListUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "commercial_invoice_uploaded",
        default: false
    })
    commercialInvoiceUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "plant_packing_list_uploaded",
        default: false
    })
    plantPackingListUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "plant_invoice_uploaded",
        default: false
    })
    plantInvoiceUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "shipment_instructions_uploaded",
        default: false
    })
    shipmentInstructionsUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "forms_thirteen_uploaded",
        default: false
    })
    formsThirteenUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "bl_drafts_uploaded",
        default: false
    })
    bLDraftUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "freight_invoice_uploaded",
        default: false
    })
    freightInvoiceUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "obl_uploaded",
        default: false
    })
    oblUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "isf_worksheet_uploaded",
        default: false
    })
    iSFWorksheetUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "simp_uploaded",
        default: false
    })
    sIMPUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "certificate_of_origin_uploaded",
        default: false
    })
    certificateOfOriginUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "declaration_of_shrimp_uploaded",
        default: false
    })
    declarationOfShrimpUploaded:boolean;


    @Column("boolean", {
        nullable: true,
        name: "health_certificate_uploaded",
        default: false
    })
    healthCertificateUploaded:boolean;

    @Column("boolean", {
        nullable: true,
        name: "survey_report_uploaded",
        default: false
    })
    surveyReportUploaded:boolean;


    @Column("varchar", {
        nullable: true,
        name: "approver_one",
    })
    approverOne: string;

    @Column("boolean", {
        nullable: true,
        name: "approver_one_status",
        default: false
    })
    approverOneStatus: boolean;

    @Column("varchar", {
        nullable: true,
        name: "approver_two",
        default: false
    })
    approverTwo: string;

    @Column("boolean", {
        nullable: false,
        name: "approver_two_status",
        default: false
    })
    approverTwoStatus: boolean;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
    @OneToOne(type=>SaleOrder, saleOrder=>saleOrder.docUpInfo ,{  nullable:false })
    @JoinColumn({ name:"sale_order_id"})
    saleOrderInfo: SaleOrder;

}